export default {
    created() {
        this.$behavior.track('PageView', {
            page: this.$t(`titles.${this.$route.name}`, 'en'),
        });
    },
};
